import { ReactNode } from "react";
import { PersonalSummaryItem } from "../constants";

function buildShownNames(
  items: PersonalSummaryItem[],
  shownCount: number,
  nameJoin: ReactNode,
  overflowLabel?: (overflowItems: PersonalSummaryItem[]) => ReactNode,
): ReactNode {
  const shownItems = items?.slice(0, shownCount);
  const overflowItems = items?.slice(shownCount);

  const shownTitles = shownItems?.reduce<ReactNode[]>((acc, item, index) => {
    if (index === 0) return [item.title];
    return [...acc, nameJoin, item.title];
  }, []);

  const defaultOverflow =
    overflowItems?.length > 0 ? `${overflowItems?.length} other${overflowItems?.length > 1 ? "s" : ""}` : null;

  const overflow = overflowLabel ? overflowLabel(overflowItems) : defaultOverflow;

  return (
    <>
      {shownTitles}
      {overflow && (
        <>
          {nameJoin}
          {overflow}
        </>
      )}
    </>
  );
}


export {buildShownNames};